import React from 'react';
import { CircularProgress as MUICircularProgress, Box } from '@mui/material';
import { cx } from '@emotion/css';
import { useStyles } from './CircularProgress.styles';
export function CircularProgress({ className, id, color = 'primary', disableShrink, size, thickness, value, variant, }) {
    const classes = useStyles();
    return (React.createElement(Box, { className: cx(classes.container, className) },
        React.createElement(MUICircularProgress, { id: id, color: color, disableShrink: disableShrink, size: size, thickness: thickness, value: value, variant: variant })));
}
//# sourceMappingURL=CircularProgress.js.map